// extracted by mini-css-extract-plugin
export default {"title":"admin_title__aTEVO","info":"admin_info__GIVd3","wrapper":"admin_wrapper__jtLX4","navlink":"admin_navlink__Ywe8r"};